import dayjs, { Dayjs } from "dayjs";
import { StorageTemperatureCondition } from "../../../../../services/orders/orders-add/types";
import { WarehouseServices } from "../../../../../services/orders/pricelist-offers-get-by-id/types";
import {
  PackageType,
  StorageGoodsType,
  StorageMethod,
  StoragePlace,
} from "../../../../../types/order-form";

export const setTimezoneDate = (date: Dayjs) => {
  return dayjs(date).format("YYYY-MM-DDTHH:mm:00.000").concat("Z");
};
export const setTimezoneDateEnd = (date: Dayjs) => {
  return dayjs(date).format("YYYY-MM-DDT23:59:59.999").concat("Z");
};

export const setPalceEnum = (value: string) => {
  switch (value) {
    case "Wewnątrz":
      return StoragePlace.Inside;
    case "Na zewnątrz":
      return StoragePlace.Outside;
  }
};

export const setTemperatureConditionEnum = (value: string) => {
  switch (value) {
    case "Nieogrzewane":
      return StorageTemperatureCondition.Nieogrzewany;
    case "Ogrzewane":
      return StorageTemperatureCondition.Ogrzewanie;
    case "Chłodnia":
      return StorageTemperatureCondition.Chlodnia;
    case "Kontrola temperatury":
      return StorageTemperatureCondition.TemperatureControl;
  }
};

export const setGoodsTypeEnum = (value: string) => {
  switch (value) {
    case "Neutralny":
      return StorageGoodsType.Neutralny;
    case "Medyczne":
      return StorageGoodsType.Medyczne;
    case "Art. Spożywcze":
      return StorageGoodsType.Spozywcze;
    case "Ciężkie ADR":
      return StorageGoodsType.DuzeADR;
    case "Inne":
      return StorageGoodsType.Inne;
  }
};

export const setStorageMethodEnum = (value: string) => {
  switch (value) {
    case "Składowanie":
      return StorageMethod.Skladowanie;
    case "Crossdocking":
      return StorageMethod.Crossdocking;
    case "Fullfilment":
      return StorageMethod.Fullfilment;
    case "Etykietowanie":
      return StorageMethod.Etykietowanie;
    case "Pakowanie":
      return StorageMethod.Pakowanie;
    case "Sortowanie":
      return StorageMethod.Sortowanie;
    case "E-commerce":
      return StorageMethod.ECommerce;
    case "Wysyłka":
      return StorageMethod.Wysylka;
    case "Inne":
      return StorageMethod.Inne;
  }
};
export const setAdditionalStorageMethodEnum = (value: string[]) => {
  const arrayOfEnums = value.map((item) => setStorageMethodEnum(item));
  return arrayOfEnums;
};

export const setPackageTypeEnum = (value: string) => {
  switch (value) {
    case "Paleta EUR":
      return PackageType.EURPallet;
    case "Paleta EUR 1/2":
      return PackageType.HalfEurPallet;
  }
};
